module.exports = import("/rms-shared-components/remoteEntry.js");